const initialState = {
    pageCode: "",
    emailNotification: [],
    doValidateNotification: false,
    receiveForm: {},
    startDateForm: {},
    endDateForm: {},
    overdueForm: {},
    isReceiveFormValid: true,
    isStartDateFormValid: false,
    isEndDateFormValid: false,
    isOverdueFormValid: false
}

const Notification = (state = initialState, action) => {
    switch (action.type) {
        case "SET_EMAIL_NOTIFICATION_PAGE_CODE":
            state = {
                ...state,
                pageCode: action.payload
            }
            return state;
        case "SET_EMAIL_NOTIFICATION_LIST":
            state = {
                ...state,
                emailNotification: action.payload
            }
            return state
        case "SET_DO_VALIDATE_EMAIL_NOTIFICATION_FORM":
            state = {
                ...state,
                doValidateNotification: action.payload
            }
            return state
        case "SET_DATA_RECEIVE_FORM":
            state = {
                ...state,
                receiveForm: action.payload
            }
            return state
        case "SET_DATA_STARTDATE_FORM":
            state = {
                ...state,
                startDateForm: action.payload
            }
            return state
        case "SET_DATA_ENDDATE_FORM":
            state = {
                ...state,
                endDateForm: action.payload
            }
            return state
        case "SET_DATA_OVERDUE_FORM":
            state = {
                ...state,
                overdueForm: action.payload
            }
            return state
        case "SET_IS_RECEIVE_FORM_VALID":
            state = {
                ...state,
                isReceiveFormValid: action.payload
            }
            return state
        case "SET_IS_STARTDATE_FORM_VALID":
            state = {
                ...state,
                isStartDateFormValid: action.payload
            }
            return state
        case "SET_IS_ENDDATE_FORM_VALID":
            state = {
                ...state,
                isEndDateFormValid: action.payload
            }
            return state
        case "SET_IS_OVERDUE_FORM_VALID":
            state = {
                ...state,
                isOverdueFormValid: action.payload
            }
            return state
        case "RESET_NOTIFICATION_TO_INITIAL_STATE":
            return {
                ...initialState,
            }
        default:
            return state
    }
}

export default Notification
